import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, show_success, htmlEscape } from "lib/helpers"

// stats--accounts-total on `app/views/stats/accounts_total.haml`.
export default class extends Controller {
  static targets = [
    "accountsTable",
    "accountDetails",
    "dateFrom",
    "dateTo",
    "exportModal",
  ]

  static values = {
    exportUrl: { type: String, default: "/stats/export_statistic" },
    accountInfoPath: { type: String, default: "/stats/account_info" },
    tableUrl: { type: String, default: "/stats/global/accounts" },
  }

  connect() {
    if (this.hasAccountsTableTarget) this.#initAccountsTable()
    this.#initDatepickers()
    this.#bindExportFieldToggles()
  }

  disconnect() {
    if (this.accountsDataTable) {
      this.accountsDataTable = destroyTurboDataTable(this.accountsDataTable)
    }
    if (this.hasDateFromTarget && $(this.dateFromTarget).data("xdsoft_datetimepicker")) {
      $(this.dateFromTarget).datetimepicker("destroy")
    }
    if (this.hasDateToTarget && $(this.dateToTarget).data("xdsoft_datetimepicker")) {
      $(this.dateToTarget).datetimepicker("destroy")
    }
    $(this.element).find(".selectAll").off(".statsAccountsTotal")
    $(this.element).find(".select_field").off(".statsAccountsTotal")
  }

  showChoiceFields(event) {
    event.preventDefault()
    $("#export-fields-modal").modal("show")
  }

  exportStatistic(event) {
    event.preventDefault()

    const selected = []
    this.element.querySelectorAll(".export_fields input:checked").forEach((input) => {
      selected.push(input.value)
    })

    if (selected.length === 0) {
      alert("Fields for export are not selected!")
      return
    }

    const dataExport = {
      date_from: this.hasDateFromTarget ? this.dateFromTarget.value : "",
      date_to: this.hasDateToTarget ? this.dateToTarget.value : "",
      fields: selected,
    }

    $.ajax({
      url: this.exportUrlValue,
      dataType: "JSON",
      data: dataExport,
      success(response) {
        if (response.success) {
          show_success(response.message, $("#workspace"))
        } else {
          show_error(response.message, $("#workspace"))
        }
      },
    })
    $("#export-fields-modal").modal("hide")
  }

  showAccountInfo(event) {
    event.preventDefault()
    const accountId = event.currentTarget.dataset.accountId
    if (!accountId) return

    $.get(`${this.accountInfoPathValue}/${accountId}`, (data) => {
      if (this.hasAccountDetailsTarget) this.accountDetailsTarget.innerHTML = data
      $("#account-info-modal").modal("show")
    })
  }

  #initAccountsTable() {
    this.accountsDataTable = createTurboDataTable(this.accountsTableTarget, {
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      scrollX: true,
      ajax: {
        url: this.tableUrlValue,
        type: "POST",
      },
      columnDefs: [
        {
          targets: 3,
          createdCell(cell, cellData, rowData) {
            $(cell).html(
              `<a href="#" data-account-id="${rowData[1]}" data-action="click->stats--accounts-total#showAccountInfo">${htmlEscape(cellData)}</a>`,
            )
          },
        },
        {
          targets: [2, 3],
          sortable: false,
        },
      ],
    })
  }

  #initDatepickers() {
    if (this.hasDateFromTarget) {
      $(this.dateFromTarget).datetimepicker({
        onGenerate: (dt) => {
          const now = new Date()
          if (now.getMonth() === dt.getMonth()) {
            dt.setMonth(dt.getMonth() - 1)
          }
          this.dateFromTarget.value = this.#formatDate(dt)
        },
        timepicker: false,
        format: "d.m.Y",
        formatDate: "d.m.Y",
        closeOnDateSelect: true,
        mask: true,
      })
    }

    if (this.hasDateToTarget) {
      $(this.dateToTarget).datetimepicker({
        onGenerate: (currentDateTime) => {
          this.dateToTarget.value = this.#formatDate(currentDateTime)
        },
        onShow: function () {
          this.setOptions({
            minDate: $("#datepicker_stat_from").val(),
            value: $("#datepicker_stat_from").val(),
          })
        },
        timepicker: false,
        format: "d.m.Y",
        formatDate: "d.m.Y",
        closeOnDateSelect: true,
        mask: true,
      })
    }
  }

  #bindExportFieldToggles() {
    $(this.element)
      .find(".selectAll")
      .on("click.statsAccountsTotal", function () {
        $(this)
          .closest(".export_fields, .modal")
          .find(".select_field")
          .prop("checked", this.checked)
      })

    $(this.element)
      .find(".select_field")
      .on("change.statsAccountsTotal", function () {
        const $fields = $(this).closest(".export_fields, .modal").find(".select_field")
        const allChecked = $fields.filter(":checked").length === $fields.length
        $(this).closest(".export_fields, .modal").find(".selectAll").prop("checked", allChecked)
      })
  }

  #formatDate(date) {
    let dd = date.getDate()
    let mm = date.getMonth() + 1
    const yy = date.getFullYear()
    if (dd < 10) dd = `0${dd}`
    if (mm < 10) mm = `0${mm}`
    return `${dd}.${mm}.${yy}`
  }
}
